import { Address } from '../generated/graphql';
import omit from 'lodash/omit';

const addressHasValues = (address: Address) => {
    if (!address) return false;
    return Object.values(omit(address, '__typename')).some(Boolean);
};

export default addressHasValues;
